import React from 'react';
import { Box, Typography, Paper, Stack, alpha } from '@mui/material';
import { ICriticalStudent } from 'services/SchoolClass/types';

interface CriticalStudentsCardProps {
  students: ICriticalStudent[];
  isLoading: boolean;
}

export const CriticalStudentsCard = React.memo(function CriticalStudentsCard({ students, isLoading }: CriticalStudentsCardProps) {
  const hasCritical = students && students.length > 0;

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 3, borderRadius: 3, border: '1px solid', 
        borderColor: (theme) => hasCritical ? 'error.main' : 'divider', 
        bgcolor: (theme) => hasCritical ? alpha(theme.palette.error.main, 0.05) : 'background.paper',
        opacity: isLoading ? 0.6 : 1, transition: 'all 0.2s ease'
      }}
    >
      <Typography variant="body2" color={hasCritical ? "error.main" : "text.secondary"} fontWeight="bold" sx={{ mb: 1 }}>
        Atenção Requerida (Crítico):
      </Typography>
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <Typography variant="h3" fontWeight="bold" color={hasCritical ? "error.main" : "text.primary"}>
          {students?.length || 0}
        </Typography>
        <Typography variant="caption" color="text.primary">
          {students?.length === 1 ? 'membro em status crítico' : 'membros em status crítico'}
        </Typography>
      </Box>

      {!hasCritical && !isLoading ? (
        <Typography variant="caption" color="success.main" fontWeight="bold" sx={{ display: 'block', py: 0.5 }}>
          ● Tudo certo! Nenhuma ausência crítica detectada no grupo.
        </Typography>
      ) : (
        <Stack 
          spacing={1.5}
          sx={{
            maxHeight: 220, // Trava de altura
            overflowY: 'auto', // Habilita o scroll vertical
            pr: 1, // Padding à direita para a barra não colar no texto
            // Customização da barra de rolagem (fina e elegante)
            '&::-webkit-scrollbar': { width: '4px' },
            '&::-webkit-scrollbar-track': { background: 'transparent' },
            '&::-webkit-scrollbar-thumb': { backgroundColor: 'divider', borderRadius: '4px' },
            '&::-webkit-scrollbar-thumb:hover': { backgroundColor: 'text.secondary' }
          }}
        >
          {students?.map((member) => (
            <Box key={member.id} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box>
                <Typography variant="caption" color={member.type === 'error' ? 'error.main' : 'warning.main'} fontWeight="bold">
                  ● {member.name}
                </Typography>
                <Typography variant="caption" display="block" color="text.secondary">{member.detail}</Typography>
              </Box>
            </Box>
          ))}
        </Stack>
      )}
    </Paper>
  );
});